export const walk = function(obj, path) {
    if (path) {
        const ar = path.split(".");
        while (ar.length) {
            const k = ar.shift();
            if (k in obj) {
                obj = obj[k];
            } else {
                obj = void 0;
                break;
            }
        }
    }
    
    return obj;
};
